export default __webpack_public_path__ + "static/media/54.8e454441.jpeg";